<template>
    <SafetyPolicies></SafetyPolicies>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SafetyPolicies = defineAsyncComponent(() =>
    import("../../components/Safety/SafetyPolicies.vue")
);

export default {
    name: "Safety_SafetyPolicies",
    components: { SafetyPolicies, AuthLayout },
};
</script>
